module.exports = __webpack_public_path__ + "assets/arrow_back.a524a0ec978b62e0cf3824c502b1a537.svg";